import { createReducer, on } from '@ngrx/store';

import { OpenModalFromComponent, CloseModalFromComponent } from './modal.actions';
import { InitialModalState } from './modal.state';

export const ModalReducer = createReducer(
    InitialModalState,

    on(OpenModalFromComponent, (state: any, { componentName, data }): any => {
        return {
            ...state,
            currentlyOpenModalData: {
                name: componentName,
                data,
            },
        };
    }),

    on(CloseModalFromComponent, (state: any): any => {
        return {
            ...state,
            currentlyOpenModalData: null,
        };
    })
);
